import { logger } from '@teko/log';
import { t } from './i18n.es.js';

const LS_POLICIES_CONFIRMED_USER_IDS = "policiesConfirmedUserIds";
const isSacombankmbPartner = (partner) => {
  return partner === "sacombankmb";
};
const checkShowConfirmPolicyModal = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      return !(userIds == null ? void 0 : userIds.includes(userId || ""));
    } catch (e) {
      logger.error(e);
    }
  }
  return true;
};
const userConfirmedPolicy = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      if (userIds && !userIds.includes(userId)) {
        userIds.push(userId);
        localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, JSON.stringify(userIds));
        return;
      }
    } catch (e) {
      logger.error(e);
    }
  }
  localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, `["${userId}"]`);
};
const getCountDownDisplay = (countdown) => {
  if (countdown === 0) {
    return t("G\u1EEDi l\u1EA1i m\xE3");
  }
  if (countdown <= 60) {
    return t("G\u1EEDi l\u1EA1i m\xE3 sau {{countdown}}s", { countdown });
  }
  const countdownMin = Math.floor(countdown / 60);
  const countdownSec = countdown % 60;
  if (countdownSec === 0) {
    return t("G\u1EEDi l\u1EA1i m\xE3 sau {{countdownMin}}p", { countdownMin });
  }
  return t("G\u1EEDi l\u1EA1i m\xE3 sau {{countdownMin}}p:{{countdownSec}}s", {
    countdownMin,
    countdownSec
  });
};

export { checkShowConfirmPolicyModal, getCountDownDisplay, isSacombankmbPartner, userConfirmedPolicy };
